import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { OwlCarouselComponent } from './components/owl-carousel/owl-carousel.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ProfileAvatarComponent } from './components/profile-avatar/profile-avatar.component';
import { NoResultsFoundComponent } from './components/no-results-found/no-results-found.component';
import { CommonFileUploadComponent } from './components/common-file-upload/common-file-upload.component';
import { NoDataInfoComponent } from './components/no-data-info/no-data-info.component';
import { RegisterUsersComponent } from './components/register-users/register-users.component';
import { StudentRegistrationFormComponent } from './components/student-registration-form/student-registration-form.component'; 
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@NgModule({
  declarations: [ConfirmModalComponent, OwlCarouselComponent, ProfileAvatarComponent, NoResultsFoundComponent, CommonFileUploadComponent,NoDataInfoComponent, RegisterUsersComponent,StudentRegistrationFormComponent],
  imports: [
    CommonModule,
    CarouselModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [ConfirmModalComponent, OwlCarouselComponent, ProfileAvatarComponent, NoResultsFoundComponent, CommonFileUploadComponent,NoDataInfoComponent, RegisterUsersComponent,StudentRegistrationFormComponent]
})
export class SharedComponentsModule { }
